import { createLucideIcon } from 'lucide-react';
export const MoneyBillIcon = createLucideIcon('money-bill-icon', [
  [
    'path',
    {
      d: 'M -1 13.5 L -8.5 17.75',
      key: '6bsi9m',
    },
  ],
  [
    'path',
    {
      d: 'M -1 31.5 L -3.5 39.25',
      key: '1ouazc',
    },
  ],
  [
    'path',
    {
      d: 'M -1.5 36 C-1.5 37.863 -0.158 39.375 1.5 39.375',
      key: '1w8tnz',
    },
  ],
  [
    'path',
    {
      d: 'M -1.5 37 C-3.158 37 -4.5 38.512 -4.5 40.375',
      key: '1e6ko8',
    },
  ],
  [
    'path',
    {
      d: 'M -13 42 L 2 42',
      key: '10wj81',
    },
  ],
  [
    'path',
    {
      d: 'M -3.5 37.5 L -3.5 44.25',
      key: 'chapvx',
    },
  ],
  [
    'path',
    {
      d: 'M -4 45 L -4 38.25',
      key: '1r6sef',
    },
  ],
  [
    'path',
    {
      d: 'M 16.5 11.625 C16.5 12.246 17.004 12.75 17.625 12.75',
      key: 'jrt6nn',
    },
  ],
  [
    'path',
    {
      d: 'M 17.625 10.5 C17.004 10.5 16.5 11.004 16.5 11.625',
      key: 'kk5jf8',
    },
  ],
  [
    'path',
    {
      d: 'M 17.625 10.5 L 18 12',
      key: 'zob2ky',
    },
  ],
  [
    'path',
    {
      d: 'M 17.625 12.75 C18.246 12.75 18.75 12.246 18.75 11.625',
      key: '1vfc69',
    },
  ],
  [
    'path',
    {
      d: 'M 18.75 11.625 C18.75 11.004 18.246 10.5 17.625 10.5',
      key: 'dmdqfz',
    },
  ],
  [
    'path',
    {
      d: 'M 2 42 L -13 42',
      key: 'yzvg5i',
    },
  ],
  [
    'path',
    {
      d: 'M 2 7.5 C2.829 7.5 3.5 6.829 3.5 6',
      key: '1c9h55',
    },
  ],
  [
    'path',
    {
      d: 'M 2.5 36 C4.158 36 15 46 5.5 32.625',
      key: '18k8mm',
    },
  ],
  [
    'path',
    {
      d: 'M 20.5 6 C20.5 6.829 21.171 7.5 22 7.5',
      key: '1vpgp9',
    },
  ],
  [
    'path',
    {
      d: 'M 22 16 C21.171 16 20.5 16.671 20.5 17.5',
      key: '190ltr',
    },
  ],
  [
    'path',
    {
      d: 'M 3.5 17.5 C3.5 16.671 2.829 16 2 16',
      key: '13zbpa',
    },
  ],
  [
    'path',
    {
      d: 'M 37.5 12.5 C37.5 10.637 36.158 9.125 34.5 9.125',
      key: '1ypmi0',
    },
  ],
  [
    'path',
    {
      d: 'M 5.25 11.625 C5.25 12.246 5.754 12.75 6.375 12.75',
      key: 'w21k4y',
    },
  ],
  [
    'path',
    {
      d: 'M 6.375 10.5 C5.754 10.5 5.25 11.004 5.25 11.625',
      key: 'shq6xh',
    },
  ],
  [
    'path',
    {
      d: 'M 6.375 10.5 L 6.5 12',
      key: '9zzikm',
    },
  ],
  [
    'path',
    {
      d: 'M 6.375 12.75 C6.996 12.75 7.5 12.246 7.5 11.625',
      key: '1puehc',
    },
  ],
  [
    'path',
    {
      d: 'M 7.5 11.625 C7.5 11.004 6.996 10.5 6.375 10.5',
      key: 'ihoyhi',
    },
  ],
  [
    'path',
    {
      d: 'M1.5 5.25V18H22.5V5.25H1.5Z',
      key: '18rps9',
    },
  ],
  [
    'path',
    {
      d: 'M12 9.75C12.8265 9.75 13.5 10.5908 13.5 11.625C13.5 12.6592 12.8265 13.5 12 13.5C11.1735 13.5 10.5 12.6592 10.5 11.625C10.5 10.5908 11.1735 9.75 12 9.75Z',
      key: '1fbyrr',
    },
  ],
]);
